export const recentTrxHistoryRequest = 'RecentTrxHistoryRequest';
export const GET_RECENT_TRX_HISTORY_DATA = 'GET_RECENT_TRX_HISTORY_DATA';
